module.exports = __webpack_public_path__ + "images/curious-8cde66bd7b045c6c33bdf2c79576475d.png";